export const generateRandomString = ({
  length = 20,
}: {
  length?: number;
} = {}): string => {
  const charset =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const values = new Uint8Array(length);
  crypto.getRandomValues(values);
  return Array.from(values)
    .map(v => charset[v % charset.length])
    .join('');
};
